import { ObjectsIndustrialPremisesConfig } from '@pigello/construct-core';
import z from 'zod/v4';
import { DefaultPresetSchema } from './default-preset-schema';
import type { PresetConfig } from './types';
import { createPresetSchema } from './utils';

/**
 * Förråd: which industrial premises categories count as storage in the market
 * flow. An empty list means no premises are treated as storage.
 */
export const ListingStorageCategoriesDataSchema = z.object({
  categories: z.array(
    z.enum(ObjectsIndustrialPremisesConfig.fields.category.validations.choices)
  ),
});

export type ListingStorageCategoriesPresetData = z.infer<
  typeof ListingStorageCategoriesDataSchema
>;

export const V1Schema = createPresetSchema(
  '1',
  ListingStorageCategoriesDataSchema
);

export const LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER =
  'listing.storagecategories';
// Single preset, so one fixed key per owner
export const LISTING_STORAGE_CATEGORIES_PRESET_KEY = 'default';

const ListingStorageCategoriesPresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.literal(LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER),
  data: V1Schema,
});

export const ListingStorageCategoriesPreset = {
  identifier: LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER,
  currentSchema: ListingStorageCategoriesPresetSchema,
  currentVersion: '1',
  migrations: null,
  single: true,
} as const satisfies PresetConfig;
